module.exports = __webpack_public_path__ + "85a556ba96c0adeb19d6a2a589d4eeda.fbx";